import { IconButton, useTheme } from '@mui/material';
import { Menu } from '@mui/icons-material';
import { getButtonInteractionStyles } from './styles';

interface MobileMenuButtonProps {
  onClick: () => void;
}

export const MobileMenuButton = ({ onClick }: MobileMenuButtonProps) => {
  const theme = useTheme();

  return (
    <IconButton
      aria-label="open mobile menu drawer"
      onClick={onClick}
      sx={{
        padding: '4px',
        display: { xs: 'flex', sm: 'none' },
        ...getButtonInteractionStyles(theme),
      }}
    >
      <Menu sx={{ fontSize: '24px' }} />
    </IconButton>
  );
};
